<template>
  <div class="page_all">
    <div class="return_link"></div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">地域グループ</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div>
        <button class="btn_plus" v-on:click="areaGroupAdd()">＋</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="h_area">グループ名</th>
            <th class="h_delete">削除</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="areaGroup in areaGroups" v-bind:key="areaGroup.group_id">
            <td class="td_area">
              <router-link v-on:click.native="areaGroupUpdate(areaGroup.group_id)" to="">{{ areaGroup.group_name }}</router-link>
            <td class="btn_delete">
              <button v-if="areaGroups.length > 0" class="btn_delete" v-on:click="areaGroupDel(areaGroup.municipality_key, areaGroup.group_id)">X</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <confirm-dialog ref="deleteDialog" modal-width='620' primary-label="削除" secondary-label="キャンセル"/>
  </div>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  components: {
    ConfirmDialog
  },
  data: function() {
    return {
      areaGroups: null,
      // メッセージ
      message: ""
    }
  },
  mounted() {
    this.getAreaGroupList()
  },
  methods: {
    async getAreaGroupList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area-group/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
        }
      })
      this.areaGroups = response.data
      console.log(this.areaGroups)
    },
    async areaGroupDel(municipality_key, group_id) {
      const group = this.areaGroups && this.areaGroups.find(group => group.group_id === group_id) || null;
      console.log(group)
      if (!group) {
        return;
      }
      const result = await this.$refs.deleteDialog.asyncShow(`${group.group_name}を削除してよろしいですか？`);
      if (!result) {
        return;
      }
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'area-group/del', {
          municipality_key: municipality_key,
          group_id: group_id,
          charge_id: this.$store.getters.getStateChargeId
        })
        this.getAreaGroupList()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    areaGroupAdd: function() {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', false)
      this.$router.push({ name: 'areaGroupDetail' })
    },
    areaGroupUpdate: function(group_id) {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', true)
      // 地域コードをStoreにセット
      this.$store.commit('setStateGroupId', group_id)
      this.$router.push({ name: 'areaGroupDetail' })
    },
  }
}
</script>

<style scoped>
.btn_general {
  margin: 0 20px 0 0;
  height: 30px;
  width: 100px;
}
table th.h_area {
  width: 312px;
}
table th.h_mytimeline {
  width: 178px;
}
table th.h_updown {
  width: 60px;
}
table th.h_delete {
  width: 50px;
}
table td {
  word-break: break-all;
}
table td.td_area {
  text-align: left;
  padding-left: 10px;
}

.mark_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding: 10px 10px 0px 0px;
  max-width: 178px;
}
.mark_outer {
  display: table;
  margin: 0px 0px 10px 10px;
}
.mark_inner {
  background-color: rgb(192,192,192);
  width: 45px;
  height: 45px;
  text-align: center;
  font-family: Arial;
  display: table-cell;
  vertical-align: middle;
  border-radius: 7px 7px 7px 7px;
  color: #F4F4F4;
}

.btn_up {
  text-align: right;
  font-size: 15px;
  border-right: none;
  width: 30px;
}
.btn_down {
  text-align: left;
  font-size: 15px;
  border-left: none;
  width: 30px;
}
.btn_delete {
  text-align: center;
  border-left: none;
  width: 20px;
}
.btn_updown {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
}
.modal_header {
  margin: 10px 0 20px 0;
}
.modal_string {
  font-size: small;
}
.modal_btn {
  margin: 0 10px 0 0;
}
</style>